import Vue from 'vue';
import axios from 'axios';
import {getNotificationsApiUrl, getConfig} from '@/utils/config';
export default {
  fetchApprovers() {
    const url = `${getNotificationsApiUrl()}/notifications/draft/approverUsers`;
    return axios.get(url, {
      headers: {
        ...Vue.prototype.$OAuth.buildHttpHeader({
          'mule-client-id': getConfig('VUE_APP_MULE_CLIENT_ID'),
          'mule-client-secret': getConfig('VUE_APP_MULE_CLIENT_SECRET'),
          Accept: "application/json",
          "Content-Type": "application/json; charset=UTF-8",
          "adfs":"true"
        }),
      }
    })
    .then((response) => {
      Vue.$log.debug('received approvers from server', response.data);
      return response.data;
    });
  },
  fetchQplusApprovers() {
    const url = `${getNotificationsApiUrl()}/notifications/draft/usersByRole/qplus_approver`;
    return axios.get(url, {
      headers: {
        ...Vue.prototype.$OAuth.buildHttpHeader({
          'mule-client-id': getConfig('VUE_APP_MULE_CLIENT_ID'),
          'mule-client-secret': getConfig('VUE_APP_MULE_CLIENT_SECRET'),
          Accept: "application/json",
          "Content-Type": "application/json; charset=UTF-8",
          "adfs":"true"
        }),
      }
    })
    .then((response) => {
      Vue.$log.debug('received qplus approvers from server', response.data);
      return response.data;
    });
  },
  fetchStaffappApprovers() {
    const url = `${getNotificationsApiUrl()}/notifications/draft/usersByRole/staffapp_approver`;
    return axios.get(url, {
      headers: {
        ...Vue.prototype.$OAuth.buildHttpHeader({
          'mule-client-id': getConfig('VUE_APP_MULE_CLIENT_ID'),
          'mule-client-secret': getConfig('VUE_APP_MULE_CLIENT_SECRET'),
          Accept: "application/json",
          "Content-Type": "application/json; charset=UTF-8",
          "adfs":"true"
        }),
      }
    })
    .then((response) => {
      Vue.$log.debug('received staffapp approvers from server', response.data);
      return response.data;
    });
  }
};
